import { nonEmptyString, BaseUrlStringCodec } from 'app/config/utils';
import * as t from 'io-ts';

const IknowCodec = t.exact(t.interface({
  origin: BaseUrlStringCodec,
  clientId: nonEmptyString,
}), 'Iknow');

export default IknowCodec;
